import { Org } from "./site";

export const getCountryRegex = (org: Org): RegExp => {
  const regexMap: Record<Org, RegExp> = {
    swe: /^(?:(?:\+46|0046)\(0\)[1-9]\d{5,8}|(?:\+46|0046)[1-9]\d{5,8}|0[1-9]\d{5,8})$/,
    ger: /^(?:(?:\+49|0049)\(0\)[1-9]\d{2,13}|(?:\+49|0049)[1-9]\d{2,13}|0[1-9]\d{2,13})$/,
    fra: /^(?:(?:\+33|0033)\(0\)[1-9]\d{8}|(?:\+33|0033)[1-9]\d{8}|\(0[1-9]\)\d{8}|0[1-9]\d{8})$/,
    gbr: /^(?:(?:\+44|0044)\(0\)[1-9]\d{8,9}|(?:\+44|0044)[1-9]\d{8,9}|0[1-9]\d{8,9})$/,
  };

  return regexMap[org];
};

export const isValidPhoneNumber = (phoneNumber: string, org: Org): boolean => {
  const regex = getCountryRegex(org);

  if (!regex) return false;

  const cleaned = phoneNumber.replaceAll(/[\s.\-/]/g, "");

  return regex.test(cleaned);
};
